
import { createContext, useContext, useState, ReactNode } from "react";

type TenancyUser = { id: string; correo_electronico: string; nombres: string; };

type Ctx = {
  tenancyToken: string | null;
  tenancyUser: TenancyUser | null;
  login: (token: string, user: TenancyUser) => void;
  logout: () => void;
};

const TenancyAuthContext = createContext<Ctx | null>(null);

export const TenancyAuthProvider = ({ children }: { children: ReactNode }) => {
  const [tenancyToken, setToken] = useState<string | null>(() => localStorage.getItem("tenancy_token"));
  const [tenancyUser, setUser] = useState<TenancyUser | null>(() => {
    const raw = localStorage.getItem("tenancy_user");
    return raw ? JSON.parse(raw) : null;
  });

  const login = (token: string, user: TenancyUser) => {
    localStorage.setItem("tenancy_token", token);
    localStorage.setItem("tenancy_user", JSON.stringify(user));
    setToken(token);
    setUser(user);
  };

  const logout = () => {
    localStorage.removeItem("tenancy_token");
    localStorage.removeItem("tenancy_user");
    setToken(null);
    setUser(null);
  };

  return (
    <TenancyAuthContext.Provider value={{ tenancyToken, tenancyUser, login, logout }}>
      {children}
    </TenancyAuthContext.Provider>
  );
};

export const useTenancyAuth = () => {
  const ctx = useContext(TenancyAuthContext);
  if (!ctx) throw new Error("useTenancyAuth must be inside TenancyAuthProvider");
  return ctx;
};
